var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2Users(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58464 6.41683C7.58464 5.12816 6.53994 4.0835 5.2513 4.0835C3.96264 4.0835 2.91797 5.12816 2.91797 6.41683C2.91797 7.70547 3.96264 8.75016 5.2513 8.75016C6.53994 8.75016 7.58464 7.70547 7.58464 6.41683Z",
    stroke: "#808080",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44049 4.40868C6.42561 4.30236 6.41797 4.19374 6.41797 4.08333C6.41797 2.79467 7.46266 1.75 8.7513 1.75C10.0399 1.75 11.0846 2.79467 11.0846 4.08333C11.0846 5.372 10.0399 6.41667 8.7513 6.41667C8.31695 6.41667 7.91037 6.29802 7.56212 6.09134",
    stroke: "#808080",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 12.25C8.75 10.317 7.18299 8.75 5.25 8.75C3.317 8.75 1.75 10.317 1.75 12.25",
    stroke: "#808080",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 9.9165C12.25 7.98351 10.683 6.4165 8.75 6.4165",
    stroke: "#808080",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Users);
export default __webpack_public_path__ + "static/media/2users.15fb77e9eecff53fd3ef362902616744.svg";
export { ForwardRef as ReactComponent };